import {
    Header,
    Sidebar,
    SidebarFooter,
    SidebarItem,
    SidebarTab,
    SidebarTabs,
    SidebarTabLabel,
    SidebarPageWrapper,
  } from '@trueprodigy/components';
  import PropTypes from 'prop-types';
  import styled from 'styled-components';
  import React, { useState, useEffect } from 'react';
  import { Helmet } from 'react-helmet';
  import { connect } from 'react-redux';
  import { withRouter } from 'react-router-dom';
  
  import * as globalActions from '@actions/global';
  import {
    isSidebarVisibleSelector,
    userStatusSelector,
    userRightsSelector,
  } from '@selectors/global';
  import SidebarCaseSettingWidget from '@components/Sidebar/SidebarCaseSettingWidget';
  import SidebarRdsNameWidget from '@components/Sidebar/SidebarRdsNameWidget';
  import SidebarAccountSettingsWidget from '@components/Sidebar/SidebarAccountSettingsWidget';
  import rocketIcon from '@modules/conferencing/assets/tp-portal_rocket.png';
  
  import conferencingLogo from '@modules/conferencing/assets/conferencing-logo.svg';
  import { parseHeaderTitle, prefix } from '@modules/conferencing/routes';
  import ability, { defineRules } from '@config/permissions/ability';
  
  const PageWrapper = ({
    children,
    location,
    toggleSidebar,
    isSidebarVisible,
    /* userStatus, */
    userRights,
  }) => {
    const [activeTab, setActiveTab] = useState(0);
    /* const isReadOnly = userStatus.get('readOnly'); */
  
    useEffect(() => {
      if (userRights && userRights.toJS() && userRights.toJS().length) {
        const rules = defineRules(userRights.toJS());
        ability.update(rules);
      }
    }, [userRights]);
  
    useEffect(() => {
      const isiPad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints;
      if (isSidebarVisible && isiPad) {
        toggleSidebar();
      }
    }, [location.pathname]);

    const isSessions = () => {
        return window.location.href.includes('/current-meetings');
    }
  
    return (
      <>
        <Helmet>
          <title>Prodigy Conferencing</title>
        </Helmet>
  
        <Sidebar
          isSidebarVisible={isSidebarVisible}
          logo={conferencingLogo}
          sidebarFooter={
            <SidebarFooter>
              <SidebarRdsNameWidget />
              <SidebarCaseSettingWidget />
              <SidebarAccountSettingsWidget />
            </SidebarFooter>
          }
        >
          <SidebarItem icon={rocketIcon} link="/" title="Prodigy App Launcher" />
          <SidebarTabs
            indicatorColor="secondary"
            scrollButtons="off"
            textColor="primary"
            value={activeTab}
            variant="fullWidth"
            onChange={(_e, i) => {
              setActiveTab(i);
            }}
          >
            <SidebarTab
              label={<SidebarTabLabel isActive={activeTab === 0} label="APP MENU" />}
            />
          </SidebarTabs>
          {activeTab === 0 ? (
            <>
            {isSessions() ? (
              <SidebarItem link={prefix + '/current-meetings'} title="Current Meetings" />
            ) : (
              <SidebarItem link={prefix + '/'} title="Current Meetings" />
            )}
            </>
          ) : null}
          <SidebarItem link={prefix + '/waiting-room-configuration'} title="Waiting Room Configuration" />
          <SidebarItem link={prefix + '/checkin-search'} title="Check In Search" />
          <SidebarItem link={prefix + '/conferencing-configuration'} title="Conferencing Configuration" />
        </Sidebar>
        <PageWrapper.ContentWrapper>
          <SidebarPageWrapper
            isSidebarVisible={isSidebarVisible}
            className="test"
            style={{ width: '100%' }}
          >
            <Header
              title={parseHeaderTitle(location.pathname)}
              toggleSidebar={toggleSidebar}
            />
            <div>{children}</div>
          </SidebarPageWrapper>
        </PageWrapper.ContentWrapper>
      </>
    );
  };
  
  PageWrapper.propTypes = {
    children: PropTypes.any,
    location: PropTypes.any,
    toggleSidebar: PropTypes.func,
    isSidebarVisible: PropTypes.bool,
    history: PropTypes.any,
    userStatus: PropTypes.any,
    userRights: PropTypes.any,
  };
  
  PageWrapper.ContentWrapper = styled.div`
    > div {
      margin-top: -67px;
      min-height: 100vh;
      background-color: #fff;
    }
  `;
  
  PageWrapper.MenuTitle = styled.div`
    height: 35px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.4);
    background-color: #fff;
    color: #2f3e9e;
    font-size: 14px;
    padding: 8px 26px;
    font-weight: normal;
  `;
  
  const mapStateToProps = state => ({
    userRights: userRightsSelector(state),
    isSidebarVisible: isSidebarVisibleSelector(state),
    userStatus: userStatusSelector(state),
  });
  
  const mapDispatchToProps = {
    toggleSidebar: globalActions.toggleSidebar,
  };
  
  export default withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(PageWrapper),
  );
  